import { Input } from 'reactstrap'

const PMBInputAmount = ({
  value = '',
  onChange,
  name,
  placeholder,
  testId = 'pmb-input-amount',
}) => (
  <Input
    type="text"
    value={value}
    onChange={onChange}
    name={name}
    placeholder={placeholder}
    data-testid={testId}
  />
)

export default PMBInputAmount
